import React from 'react';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <img src="/images/logo_image.webp" alt="FundMeWiz" className="loader-logo" />
      <div className="spinner"></div>
    </div>
  );
};

export default PageLoader;
